// extracted by mini-css-extract-plugin
export default {"backImg":"a_backImg__0e3rf","backImgContainer":"a_backImgContainer__lNQOP"};